import {
    ListItemButton as MuiListItemButton,
    Radio as MuiRadio,
    RadioGroup as MuiRadioGroup,
    styled,
} from "@mui/material"

export const RadioGroup = styled(MuiRadioGroup)(({
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
}))

export const Radio = styled(MuiRadio)({
    marginLeft: "auto",
})

export const Typography = styled("div")(({ theme, variant }) => ({
    alignSelf: "stretch",
    alignItems: "center",
    display: "flex",
    marginLeft: theme.spacing(8),
    fontWeight: theme.typography[variant].fontWeight,
}))

export const ListItemButton = styled(MuiListItemButton, {
    shouldForwardProp: (prop) => prop !== "isDisabled",
})(({ isDisabled, selected, theme }) => {

    const backgroundColor = isDisabled ? "surfaces/surface-disabled"
        : selected ? "surfaces/surface-variation"
            : "surfaces/surface-primary"

    return ({
        "&:hover": {
            backgroundColor: isDisabled ? `${theme.palette["surfaces/surface-disabled"].main} !important`
                : `${theme.palette["surfaces/surface-variation"].main} !important`,
        },
        "&:active": {
            backgroundColor: isDisabled && `${theme.palette["surfaces/surface-disabled"].main} !important`,
        },
        backgroundColor: `${theme.palette[backgroundColor].main} !important`,
        border: `2px solid ${selected ? theme.palette["cta-bg/cta-bg-primary"].main : theme.palette["surfaces/surface-primary"].main}`,
        borderRadius: 12,
        cursor: isDisabled ? "default" : "pointer",
        display: "flex",
        fontSize: selected ? theme.typography["H3"].fontSize : theme.typography["Regular"].fontSize,
        fontWeight: selected ? theme.typography["H3"].fontWeight : theme.typography["Regular"].fontWeight,
        justifyContent: "space-between",
        height: "fit-content",
        opacity: isDisabled && "1 !important",
        padding: theme.spacing(1, 4),
        width: "100%",
    })
})